// project imports
import Utils from "./utils"
import * as keys from "./keys"
import { COOKIE_PARA_NAME_FOR_JOURNEY_ID } from "constants/Constants";
import getCookie from "utils/journeyIdCookie/getJourneyId";
import axios from "axios";
import * as APITypes from "../../../../../constants/API";
import moment from "moment";
import OptimizationStore from "../../../../../modules/optimization/store/OptimizationStore";
import utils from "./utils";

const FormObserver = (formRef, props) => {
    let biRequest = props.data.bi_request;

    let liAge = Number(biRequest.LI_ENTRY_AGE)
    let policyTerm = biRequest.PR_PT
    let secondaryLaName = biRequest.SecondLifeAssuredName
    let secondaryLaGendar = biRequest.SecondLifeAssuredGender
    let secondaryLaDOB = biRequest.SecondLifeAssuredDOB
    let PT_value = biRequest.PT_VALUE

    formRef.$('plan-option').observe({
        key: 'value',
        call: async ({ field }) => {
            let requestData = {}

            // formRef.$('age-based-withdrawal').set('extra', { ...formRef.$('age-based-withdrawal').extra, hide: true })
            if (Number(field.value.id) === 2) {

                // OptimizationStore.setSelectedNeed(props.cardKey);
                // let journey_id = getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID)
                // // let cardKey = Utils.fetchNeedID(props.cardKey)
                // OptimizationStore.getEligibleLaList(journey_id, props.cardKey, "CHILD", true, "addsecondary");
                // OptimizationStore.setSelectedNeedCardData(props.data)

                //let data = Utils.fetchMinorDta("1700", 1, "secondary", true)
                // const laListResponse = await axios.post(APITypes.GET_ELIGIBLE_LA_LIST, {
                //     journey_id: getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID),
                //     need_id: Utils.fetchNeedID(props.cardKey),
                //     secondary_la_product: true,
                //     required_la: 'secondary',
                // })
                // console.log("data>>>>", laListResponse?.data)

                // if (laListResponse?.data?.length > 0) {
                //     requestData = {
                //         planOption: field.value.id,
                //         SecondLifeAssuredName: laListResponse?.data[0]?.first_name,
                //         SecondLifeAssuredLastName: laListResponse?.data[0]?.last_name,
                //         SecLaDOB: moment(laListResponse?.data[0]?.dob).format('YYYY-MM-DD'),
                //         secondLifeAssuredGender: laListResponse?.data[0]?.gender === "Male" ? "4" : "5"
                //     }
                //     let gender = laListResponse?.data[0]?.gender === "Male" ? { label: 'Male', id: "4" } : { label: 'Female', id: "5" }

                //     formRef.$('second-life-assured-first-name').set('extra', { ...formRef.$('second-life-assured-first-name').extra, hide: true })
                //     formRef.$('second-life-assured-first-name').set('value', laListResponse?.data[0].first_name)
                //     formRef.$('second-life-assured-last-name').set('extra', { ...formRef.$('second-life-assured-last-name').extra, hide: true })
                //     formRef.$('second-life-assured-last-name').set('value', laListResponse?.data[0].last_name)
                //     formRef.$('second-life-assured-dob').set('extra', { ...formRef.$('second-life-assured-dob').extra, hide: true })
                //     formRef.$('second-life-assured-dob').set('value', laListResponse?.data[0].dob)
                //     formRef.$('second-life-assured-gender').set('extra', { ...formRef.$('second-life-assured-gender').extra, hide: true })
                //     formRef.$('second-life-assured-gender').set('value', gender)
                // } else {
                //     requestData = {
                //         planOption: field.value.id,
                //         SecondLifeAssuredName: "",
                //         SecondLifeAssuredLastName: "",
                //         SecLaDOB: "",
                //         secondLifeAssuredGender: ""
                //     }

                //     formRef.$('second-life-assured-first-name').set('extra', { ...formRef.$('second-life-assured-first-name').extra, hide: true })
                //     formRef.$('second-life-assured-last-name').set('extra', { ...formRef.$('second-life-assured-last-name').extra, hide: true })
                //     formRef.$('second-life-assured-dob').set('extra', { ...formRef.$('second-life-assured-dob').extra, hide: true })
                //     formRef.$('second-life-assured-gender').set('extra', { ...formRef.$('second-life-assured-gender').extra, hide: true })
                // }


            } else {
                // requestData = {
                //     planOption: field.value.id,
                // SecondLifeAssuredName: "",
                // SecondLifeAssuredLastName: "",
                // SecLaDOB: "",
                // secondLifeAssuredGender: "",
                // }

                // formRef.$('PayorWaiverBenefitRider').set('value', false)
                // formRef.$('second-life-assured-first-name').set('extra', { ...formRef.$('second-life-assured-first-name').extra, hide: false })
                // formRef.$('second-life-assured-last-name').set('extra', { ...formRef.$('second-life-assured-last-name').extra, hide: false })
                // formRef.$('second-life-assured-dob').set('extra', { ...formRef.$('second-life-assured-dob').extra, hide: false })
                // formRef.$('second-life-assured-gender').set('extra', { ...formRef.$('second-life-assured-gender').extra, hide: false })
            }
            Utils.updateBi(keys.PLAN_OPTION, field.value.id, props.data.package_id, formRef, props)
        }
    })

    formRef.$('two-gether-option').observe({
        key: 'value',
        call: async ({ field }) => {
            let requestData = {}
            // formRef.$('age-based-withdrawal').set('extra', { ...formRef.$('age-based-withdrawal').extra, hide: true })
            if (Number(field.value.id) === 22) {
                OptimizationStore.setSelectedNeed(props.cardKey);
                let journey_id = getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID)
                // let cardKey = Utils.fetchNeedID(props.cardKey)
                OptimizationStore.getEligibleLaList(journey_id, props.cardKey, "CHILD", true, "addsecondary", props?.data?.bi_request?.packageId);
                OptimizationStore.setSelectedNeedCardData(props.data)
                // formRef.$('death-benefit-option').set('extra', { ...formRef.$('death-benefit-option').extra, optionList: [{ label: 'Option 1', id: 24 },] })

            } else {
                requestData = {
                    twogetherOption: field.value.id,
                    SecondLifeAssuredName: "",
                    SecondLifeAssuredLastName: "",
                    SecLaDOB: "",
                    secondLifeAssuredGender: "",
                }
                // formRef.$('death-benefit-option').set('extra', {
                //     ...formRef.$('death-benefit-option').extra,
                //     optionList: [
                //         { label: 'Option 1', id: 24 },
                //         { label: 'Option 2', id: 25 }
                //     ]
                // })

                formRef.$('PayorWaiverBenefitRider').set('value', false)
                formRef.$('second-life-assured-first-name').set('extra', { ...formRef.$('second-life-assured-first-name').extra, hide: false })
                formRef.$('second-life-assured-last-name').set('extra', { ...formRef.$('second-life-assured-last-name').extra, hide: false })
                formRef.$('second-life-assured-dob').set('extra', { ...formRef.$('second-life-assured-dob').extra, hide: false })
                formRef.$('second-life-assured-gender').set('extra', { ...formRef.$('second-life-assured-gender').extra, hide: false })
            }
            Utils.updateBi(keys.TWO_GETHER_OPTION, requestData, props.data.package_id, formRef, props)
        }
    })


    formRef.$('second-life-assured-first-name').observe({
        key: 'value',
        call: ({ field }) => {

            Utils.updateBi(keys.SECOND_LIFE_ASSURED_NAME, field.value, props.data.package_id, formRef, props)
        }
    })

    formRef.$('second-life-assured-last-name').observe({
        key: 'value',
        call: ({ field }) => {

            Utils.updateBi(keys.SECOND_LIFE_ASSURED_LAST_NAME, field.value, props.data.package_id, formRef, props)

        }
    })

    formRef.$('second-life-assured-dob').observe({
        key: 'value',
        call: ({ field }) => {
            let secondaryLADob = moment(field.value, 'DD-MM-YYYY').format("YYYY-MM-DD")
            Utils.updateBi(keys.SecLaDOB, secondaryLADob, props.data.package_id, formRef, props)
        }
    })

    formRef.$('second-life-assured-gender').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.updateBi(keys.SECOND_LIFE_ASSURED_GENDER, field.value.id, props.data.package_id, formRef, props)

        }
    })




    // !PPT
    formRef.$('premium-term').observe({
        key: 'value',
        call: ({ field }) => {
            // let planOption = Number(formRef.$('plan-option').value.id)
            // let pt = formRef.$('policy-term').value.id
            let ppt = Number(field.value.id)
            let pt = formRef.$('policy-term').value.id

            // !PT
            // let ptList = Utils.policyTermList(planOption, ppt, liAge)
            // let ptExist = ptList.some((item) => item.id.toString() === policyTerm.toString())
            // formRef.$('policy-term').set('extra', { ...formRef.$('policy-term').extra, optionList: ptList })
            // if (!ptExist) formRef.$('policy-term').set('value', ptList[0])
            let propositionList = utils.propositionList(String(pt), Number(ppt))
            if (propositionList?.length > 0) {
                formRef.$("proposition").set("extra", {
                    ...formRef.$("proposition").extra,
                    optionList: propositionList || [],
                });
                formRef.$('proposition').set('value', propositionList[0])
            }

            let requestData = {
                ppt: field.value.id,
            }

            Utils.updateBi(keys.PR_PPT, requestData, props.data.package_id, formRef, props)
        }
    })

    // !Income start year
    // formRef.$('income-start-year').observe({
    // 	key: 'value',
    // 	call: ({ field }) => {
    // 		Utils.updateBi(keys.INCOME_START_YEAR, field.value.id, props.data.package_id, formRef, props)
    // 	}
    // })

    // !PT
    formRef.$('policy-term').observe({
        key: 'value',
        call: ({ field }) => {

            let ppt = formRef.$('premium-term').value.id
            let pt = field.value.id
            // let ptValue = pt === '100-@LI_ENTRY_AGE' ? 100 - liAge : Number(pt)
            // let isLifeCoverContinuationBenefitDisabled = Utils.checkLifeCoverDisabled(ppt, ptValue, liAge)
            // formRef.$('life-cover').set('disabled', isLifeCoverContinuationBenefitDisabled)
            // if (isLifeCoverContinuationBenefitDisabled) {
            //     formRef.$('life-cover').set('value', { label: 'No', id: "10" })
            // }

            // let requestData = {
            //     lifeCoverContinuationBenefit: formRef.$('life-cover').value.id,
            //     pt: field.value.id,
            // }

            let pptList = utils.pptListBasedOnPlanOption(pt)
            formRef.$('premium-term').set('extra', { ...formRef.$('premium-term').extra, optionList: pptList })
            formRef.$('premium-term').set('value', pptList[0])

            let propositionList = utils.propositionList(String(pt), Number(ppt))
            if (propositionList?.length > 0) {
                formRef.$("proposition").set("extra", {
                    ...formRef.$("proposition").extra,
                    optionList: propositionList || [],
                });
                formRef.$('proposition').set('value', propositionList[0])
            }

            let requestData = {
                ppt: pptList[0],
                pt: field.value.id,
            }
            Utils.updateBi(keys.PR_PT, requestData, props.data.package_id, formRef, props)
        }
    })

    // !Life Cover Continuation Benefit
    // formRef.$('life-cover').observe({
    // 	key: 'value',
    // 	call: ({ field }) => {
    // 		Utils.updateBi(keys.LIFE_COVER_CONTINUATION_BENEFIT, field.value.id, props.data.package_id, formRef, props)
    // 	}
    // })

    // !Payment frequency
    formRef.$('payment-frequency').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.updateBi(keys.FREQUENCY, field.value.id, props.data.package_id, formRef, props)
        }
    })
    // !income-frequency-mode
    formRef.$('income-frequency-mode').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.updateBi(keys.INCOME_FREQUENCY_MODE, field.value.id, props.data.package_id, formRef, props)
        }
    })

    // !Accrual Of Survival Benefits
    formRef.$('accrual-of-survival-benefit').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.handleAsbCondition(formRef, field.value.id)
            let asbStartYear1 = ""
            let asbEndYear1 = ""
            let asb2 = ""
            let asbStartYear2 = ""
            let asbEndYear2 = ""
            let asb3 = ""
            let asbStartYear3 = ""
            let asbEndYear3 = ""


            if (field.value.id === 10) {
                Utils.handleASBstartPolicyOneConditions(formRef, props.data.product_name, PT_value, liAge)

                if (formRef.$('asb-start-age-(1st-opt-in)').value) {
                    asbStartYear1 = formRef.$('asb-start-age-(1st-opt-in)').value.id
                }
                if (formRef.$('asb-end-age-(1st-opt-in)').value) {
                    asbEndYear1 = formRef.$('asb-end-age-(1st-opt-in)').value.id
                }
                asb2 = formRef.$('accrual-of-survival-benefits-year-2').value.id
                if (formRef.$('asb-start-age-(2nd-opt-in)').value) {
                    asbStartYear2 = formRef.$('asb-start-age-(2nd-opt-in)').value.id
                }
                if (formRef.$('asb-end-age-(2nd-opt-in)').value) {
                    asbEndYear2 = formRef.$('asb-end-age-(2nd-opt-in)').value.id
                }
                asb3 = formRef.$('accrual-of-survival-benefits-year-3').value.id
                if (formRef.$('asb-start-age-(3rd-opt-in)').value) {
                    asbStartYear3 = formRef.$('asb-start-age-(3rd-opt-in)').value.id
                }
                if (formRef.$('asb-end-age-(3rd-opt-in)').value) {
                    asbEndYear3 = formRef.$('asb-end-age-(3rd-opt-in)').value.id
                }

            }
            let requestData = {
                asb1: field.value.id,
                asbStartYear1,
                asbEndYear1,
                asb2,
                asbStartYear2,
                asbEndYear2,
                asb3,
                asbStartYear3,
                asbEndYear3,
            }
            Utils.updateBi(keys.ACCRUALOFSURVIVALBENEFIT_1, requestData, props.data.package_id, formRef, props)
        }
    })

    formRef.$('asb-start-age-(1st-opt-in)').observe({
        key: 'value',
        call: ({ field }) => {
            let asb2 = ""
            let asbStartYear2 = ""
            let asbEndYear2 = ""
            let asb3 = ""
            let asbStartYear3 = ""
            let asbEndYear3 = ""

            Utils.handleASBFirstStartEndCondition(formRef, formRef.$('accrual-of-survival-benefit').value.id)
            let asbEndYearOneList = Utils.fetchASBendPolicyOne(field.value.id, formRef.$("asb-start-age-(1st-opt-in)").extra.optionList, formRef.$("asb-end-age-(1st-opt-in)").extra.preDefinedOptList)
            formRef.$("asb-end-age-(1st-opt-in)").set("extra", {
                ...formRef.$("asb-end-age-(1st-opt-in)").extra,
                optionList: asbEndYearOneList,
            });
            let selectedAsbEndYearOne = asbEndYearOneList.some((item) => item.id === formRef.$("asb-end-age-(1st-opt-in)").value?.id);
            if (!selectedAsbEndYearOne) {
                let optData = asbEndYearOneList.find((item) => item.label === field.value.label)
                formRef
                    .$("asb-end-age-(1st-opt-in)")
                    .set("value", optData);
            }
            if (Number(field.value.label) === Number(99) || Number(formRef.$("asb-end-age-(1st-opt-in)").value.label) === Number(99)) {
                formRef.$('accrual-of-survival-benefits-year-2').set("disabled", true)
            } else {
                formRef.$('accrual-of-survival-benefits-year-2').set("disabled", false)
            }
            asb2 = formRef.$('accrual-of-survival-benefits-year-2').value.id
            if (formRef.$('asb-start-age-(2nd-opt-in)').value) {
                asbStartYear2 = formRef.$('asb-start-age-(2nd-opt-in)').value.id
            }
            if (formRef.$('asb-end-age-(2nd-opt-in)').value) {
                asbEndYear2 = formRef.$('asb-end-age-(2nd-opt-in)').value.id
            }
            asb3 = formRef.$('accrual-of-survival-benefits-year-3').value.id
            if (formRef.$('asb-start-age-(3rd-opt-in)').value) {
                asbStartYear3 = formRef.$('asb-start-age-(3rd-opt-in)').value.id
            }
            if (formRef.$('asb-end-age-(3rd-opt-in)').value) {
                asbEndYear3 = formRef.$('asb-end-age-(3rd-opt-in)').value.id
            }

            let requestData = {
                asbStart1: field.value.id,
                asbEnd1: formRef.$("asb-end-age-(1st-opt-in)").value.id,
                asb2,
                asbStartYear2,
                asbEndYear2,
                asb3,
                asbStartYear3,
                asbEndYear3,
            }
            Utils.updateBi(keys.ASB_STARTPOLICYYEAR_1, requestData, props.data.package_id, formRef, props)
        }
    })


    formRef.$('asb-end-age-(1st-opt-in)').observe({
        key: 'value',
        call: ({ field }) => {
            let asb2 = ""
            let asbStartYear2 = ""
            let asbEndYear2 = ""
            let asb3 = ""
            let asbStartYear3 = ""
            let asbEndYear3 = ""
            Utils.handleASBFirstStartEndCondition(formRef, formRef.$('accrual-of-survival-benefit').value.id)
            asb2 = formRef.$('accrual-of-survival-benefits-year-2').value.id

            if (Number(field.value.label) >= Number(99) || Number(formRef.$("asb-start-age-(1st-opt-in)").value.label) === Number(99)) {
                formRef.$('accrual-of-survival-benefits-year-2').set("disabled", true)
            } else {
                formRef.$('accrual-of-survival-benefits-year-2').set("disabled", false)
            }
            if (formRef.$('asb-start-age-(2nd-opt-in)').value) {
                asbStartYear2 = formRef.$('asb-start-age-(2nd-opt-in)').value.id
            }
            if (formRef.$('asb-end-age-(2nd-opt-in)').value) {
                asbEndYear2 = formRef.$('asb-end-age-(2nd-opt-in)').value.id
            }
            asb3 = formRef.$('accrual-of-survival-benefits-year-3').value.id
            if (formRef.$('asb-start-age-(3rd-opt-in)').value) {
                asbStartYear3 = formRef.$('asb-start-age-(3rd-opt-in)').value.id
            }
            if (formRef.$('asb-end-age-(3rd-opt-in)').value) {
                asbEndYear3 = formRef.$('asb-end-age-(3rd-opt-in)').value.id
            }
            let requestData = {
                asbEnd1: field.value.id || "",
                asb2,
                asbStartYear2,
                asbEndYear2,
                asb3,
                asbStartYear3,
                asbEndYear3,
            }
            Utils.updateBi(keys.ASB_ENDPOLICYYEAR_1, requestData, props.data.package_id, formRef, props)
        }
    })

    formRef.$('withdrawal-parcentage-1').observe({
        key: 'value',
        call: ({ field }) => {

            Utils.updateBi(keys.ASB_WITHDRAWALPERCENTAGE_1, field.value.id, props.data.package_id, formRef, props)

        }
    })
    formRef.$('accrual-of-survival-benefits-year-2').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.handleAsbTwoCondition(formRef, field.value.id)
            let asbStartYear2 = ""
            let asbEndYear2 = ""
            let asb3 = ""
            let asbStartYear3 = ""
            let asbEndYear3 = ""
            if (field.value.id === 315) {
                Utils.handleASBTwostartPolicyOneConditions(formRef)
                if (formRef.$('asb-start-age-(2nd-opt-in)').value) {
                    asbStartYear2 = formRef.$('asb-start-age-(2nd-opt-in)').value.id
                }
                if (formRef.$('asb-end-age-(2nd-opt-in)').value) {
                    asbEndYear2 = formRef.$('asb-end-age-(2nd-opt-in)').value.id
                }
                asb3 = formRef.$('accrual-of-survival-benefits-year-3').value.id
                if (formRef.$('asb-start-age-(3rd-opt-in)').value) {
                    asbStartYear3 = formRef.$('asb-start-age-(3rd-opt-in)').value.id
                }
                if (formRef.$('asb-end-age-(3rd-opt-in)').value) {
                    asbEndYear3 = formRef.$('asb-end-age-(3rd-opt-in)').value.id
                }

            }
            let requestData = {
                asb2: field.value.id,
                asbStartYear2,
                asbEndYear2,
                asb3,
                asbStartYear3,
                asbEndYear3,
            }
            Utils.updateBi(keys.ACCRUALOFSURVIVALBENEFIT_2, requestData, props.data.package_id, formRef, props)
        }
    })

    formRef.$('asb-start-age-(2nd-opt-in)').observe({
        key: 'value',
        call: ({ field }) => {
            let asb3 = ""
            let asbStartYear3 = ""
            let asbEndYear3 = ""
            Utils.handleASBTwoStartEndCondition(formRef, formRef.$('accrual-of-survival-benefits-year-2').value.id)
            let asbTwoEndYearOneList = Utils.fetchASBendPolicyOne(field.value.id, formRef.$("asb-start-age-(2nd-opt-in)").extra.optionList, formRef.$("asb-end-age-(2nd-opt-in)").extra.preDefinedOptList);
            formRef.$("asb-end-age-(2nd-opt-in)").set("extra", {
                ...formRef.$("asb-end-age-(2nd-opt-in)").extra,
                optionList: asbTwoEndYearOneList,
            });
            let selectedAsbTwoEndYearOne = asbTwoEndYearOneList.some((item) => item.id === formRef.$("asb-end-age-(2nd-opt-in)").value?.id);
            if (!selectedAsbTwoEndYearOne) {
                let optData = asbTwoEndYearOneList.find((item) => item.label === field.value.label)
                formRef
                    .$("asb-end-age-(2nd-opt-in)")
                    .set("value", optData);
            }
            if (Number(field.value.label) === Number(99) || Number(formRef.$("asb-end-age-(2nd-opt-in)").value.label) === Number(99)) {
                formRef.$('accrual-of-survival-benefits-year-3').set("disabled", true)
            } else {
                formRef.$('accrual-of-survival-benefits-year-3').set("disabled", false)
            }
            asb3 = formRef.$('accrual-of-survival-benefits-year-3').value.id
            if (formRef.$('asb-start-age-(3rd-opt-in)').value) {
                asbStartYear3 = formRef.$('asb-start-age-(3rd-opt-in)').value.id
            }
            if (formRef.$('asb-end-age-(3rd-opt-in)').value) {
                asbEndYear3 = formRef.$('asb-end-age-(3rd-opt-in)').value.id
            }

            let requestData = {
                asbStartYear2: field.value.id,
                asbEndYear2: formRef.$("asb-end-age-(2nd-opt-in)").value.id,
                asb3,
                asbStartYear3,
                asbEndYear3,
                asbEndYear3,

            }
            Utils.updateBi(keys.ASB_STARTPOLICYYEAR_2, requestData, props.data.package_id, formRef, props)
        }
    })

    formRef.$('asb-end-age-(2nd-opt-in)').observe({
        key: 'value',
        call: ({ field }) => {
            let asb3 = ""
            let asbStartYear3 = ""
            let asbEndYear3 = ""
            Utils.handleASBTwoStartEndCondition(formRef, formRef.$('accrual-of-survival-benefits-year-2').value.id)
            asb3 = formRef.$('accrual-of-survival-benefits-year-3').value.id
            if (Number(field.value.label) >= Number(99) || Number(formRef.$("asb-start-age-(2nd-opt-in)").value.label) === Number(99)) {
                formRef.$('accrual-of-survival-benefits-year-3').set("disabled", true)
            } else {
                formRef.$('accrual-of-survival-benefits-year-3').set("disabled", false)
            }
            if (formRef.$('asb-start-age-(3rd-opt-in)').value) {
                asbStartYear3 = formRef.$('asb-start-age-(3rd-opt-in)').value.id
            }
            if (formRef.$('asb-end-age-(3rd-opt-in)').value) {
                asbEndYear3 = formRef.$('asb-end-age-(3rd-opt-in)').value.id
            }

            let requestData = {
                asbEndYear2: field.value.id || "",
                asb3,
                asbStartYear3,
                asbEndYear3,
            }
            Utils.updateBi(keys.ASB_ENDPOLICYYEAR_2, requestData, props.data.package_id, formRef, props)
        }
    })

    formRef.$('withdrawal-parcentage-2').observe({
        key: 'value',
        call: ({ field }) => {

            Utils.updateBi(keys.ASB_WITHDRAWALPERCENTAGE_2, field.value.id, props.data.package_id, formRef, props)

        }
    })

    formRef.$('accrual-of-survival-benefits-year-3').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.handleAsbThreeCondition(formRef, field.value.id)
            let asbStartYear3 = ""
            let asbEndYear3 = ""

            if (field.value.id === 620) {
                Utils.handleASBThreestartPolicyOneConditions(formRef)
                if (formRef.$('asb-start-age-(3rd-opt-in)').value) {
                    asbStartYear3 = formRef.$('asb-start-age-(3rd-opt-in)').value.id
                }
                if (formRef.$('asb-end-age-(3rd-opt-in)').value) {
                    asbEndYear3 = formRef.$('asb-end-age-(3rd-opt-in)').value.id
                }

            }
            let requestData = {
                asb3: field.value.id,
                asbStartYear3,
                asbEndYear3,
            }
            Utils.updateBi(keys.ACCRUALOFSURVIVALBENEFIT_3, requestData, props.data.package_id, formRef, props)
        }
    })

    formRef.$('asb-start-age-(3rd-opt-in)').observe({
        key: 'value',
        call: ({ field }) => {
            let asbThreeEndYearOneList = Utils.fetchASBendPolicyOne(field.value.id, formRef.$("asb-start-age-(3rd-opt-in)").extra.optionList, formRef.$("asb-end-age-(3rd-opt-in)").extra.preDefinedOptList);
            formRef.$("asb-end-age-(3rd-opt-in)").set("extra", {
                ...formRef.$("asb-end-age-(3rd-opt-in)").extra,
                optionList: asbThreeEndYearOneList,
            });
            let selectedAsbThreeEndYearOne = asbThreeEndYearOneList.some((item) => item.id === formRef.$("asb-end-age-(3rd-opt-in)").value?.id);
            if (!selectedAsbThreeEndYearOne) {
                let optData = asbThreeEndYearOneList.find((item) => item.label === field.value.label)
                formRef
                    .$("asb-end-age-(3rd-opt-in)")
                    .set("value", optData);
            }

            let requestData = {
                asbStartYear3: field.value.id || "",
                asbEndYear3: formRef.$("asb-end-age-(3rd-opt-in)").value.id,

            }
            Utils.updateBi(keys.ASB_STARTPOLICYYEAR_3, requestData, props.data.package_id, formRef, props)
        }
    })

    formRef.$('asb-end-age-(3rd-opt-in)').observe({
        key: 'value',
        call: ({ field }) => {
            let requestData = {
                asbEndYear3: field.value.id || "",
            }
            Utils.updateBi(keys.ASB_ENDPOLICYYEAR_3, requestData, props.data.package_id, formRef, props)
        }
    })

    formRef.$('withdrawal-parcentage-3').observe({
        key: 'value',
        call: ({ field }) => {

            Utils.updateBi(keys.ASB_WITHDRAWALPERCENTAGE_3, field.value.id, props.data.package_id, formRef, props)

        }
    })

    formRef.$('maturity-benefit-payment-mode').observe({
        key: 'value',
        call: ({ field }) => {
            if (Number(field.value.id) === 930) {
                formRef.$('maturity-benefit-lumpsum-percentage').set('disabled', false)
            } else {
                formRef.$('maturity-benefit-lumpsum-percentage').set('value', '')
                formRef.$('maturity-benefit-lumpsum-percentage').set('disabled', true)
            }
            Utils.updateBi(keys.MATURITY_BENEFIT_PAYMENT_MODE, field.value.id, props.data.package_id, formRef, props)

        }
    })
    formRef.$('maturity-benefit-lumpsum-percentage').observe({
        key: 'value',
        call: ({ field }) => {

            Utils.updateBi(keys.MATURITY_BENEFIT_LUMSUM, field.value.id, props.data.package_id, formRef, props)

        }
    })
    formRef.$('number-of-months-maturity-benefit-paid').observe({
        key: 'value',
        call: ({ field }) => {

            Utils.updateBi(keys.MATURITY_BENEFIT_IS_PAID, field.value.id, props.data.package_id, formRef, props)

        }
    })
    formRef.$('death-benefit-payment-mode').observe({
        key: 'value',
        call: ({ field }) => {

            if (Number(field.value.id) === 1034) {
                formRef.$('death-benefit-lumpsum-percentage').set('disabled', false)
            } else {
                formRef.$("death-benefit-lumpsum-percentage").set("value", '')
                formRef.$('death-benefit-lumpsum-percentage').set('disabled', true)
            }

            Utils.updateBi(keys.DEATH_BENEFIT_PAYMENT_MODE, field.value.id, props.data.package_id, formRef, props)

        }
    })
    formRef.$('death-benefit-lumpsum-percentage').observe({
        key: 'value',
        call: ({ field }) => {

            Utils.updateBi(keys.DEATH_BENEFIT_LUMSUM, field.value.id, props.data.package_id, formRef, props)

        }
    })
    formRef.$('number-of-months-death-benefit-paid').observe({
        key: 'value',
        call: ({ field }) => {

            Utils.updateBi(keys.DEATH_BENEFIT_IS_PAID, field.value.id, props.data.package_id, formRef, props)

        }
    })
    formRef.$('survival-benefit-advance').observe({
        key: 'value',
        call: ({ field }) => {

            Utils.updateBi(keys.SURVIVAL_BENEFIT_IN_ADVANCE, field.value.id, props.data.package_id, formRef, props)

        }
    })
    formRef.$('total-survival-benefit').observe({
        key: 'value',
        call: ({ field }) => {

            Utils.updateBi(keys.TOTAL_SURVIVAL_BENEFIT, field.value.id, props.data.package_id, formRef, props)

        }
    })

    formRef.$('death-benefit-option').observe({
        key: 'value',
        call: ({ field }) => {

            Utils.updateBi(keys.DEATH_BENEFIT_OPTION, field.value.id, props.data.package_id, formRef, props)

        }
    })

    formRef.$('proposition').observe({
        key: 'value',
        call: ({ field }) => {
            if (Number(field.value.id) === 2 || Number(field.value.id) === 4) {
                formRef.$('accrual-period').set('disabled', false)
            } else {
                formRef.$('accrual-period').set('disabled', true)
                formRef.$('accrual-period').set('value',)
            }
            let ropList = utils.ropList(Number(field.value.id))
            // if (ropList.length > 0) {
            formRef.$("ROP").set("extra", {
                ...formRef.$("ROP").extra,
                optionList: ropList || [],
            });
            if (Number(field.value.id) === 1 || Number(field.value.id) === 340) {
                formRef.$('ROP').set('disabled', true)
            } else {
                formRef.$('ROP').set('disabled', false)
            }
            formRef.$("ROP").set("value", "")
            // }

            let planOptionList = utils.planOptionList(Number(field.value.id))
            if (planOptionList?.length > 0) {
                formRef.$("plan-option").set("extra", {
                    ...formRef.$("plan-option").extra,
                    optionList: planOptionList || [],
                });

                formRef.$("plan-option").set("value", planOptionList[0])
            }

            let asbList = [{ label: 'Yes', id: 29 }]
            let survivalBenefitList = []
            if (Number(field.value.id) === 3 || Number(field.value.id) === 340) {
                if (Number(field.value.id) === 340) {
                    asbList.push({ label: 'No', id: 30 })
                }
                survivalBenefitList.push({ label: 'Yes', id: 926 })
            } else {
                formRef.$("accrual-of-survival-benefit").set("value", asbList[0])
            }
            formRef.$("accrual-of-survival-benefit").set("extra", {
                ...formRef.$("accrual-of-survival-benefit").extra,
                optionList: asbList || [],
            });
            survivalBenefitList.push({ label: 'No', id: 927 },)
            formRef.$("survival-benefit-advance").set("extra", {
                ...formRef.$("survival-benefit-advance").extra,
                optionList: survivalBenefitList || [],
            });
            let incomeFrequencyModeList = [{ label: 'Annual', id: 334 }]
            if (Number(field.value.id) === 2 || Number(field.value.id) === 3 || Number(field.value.id) === 4 || Number(field.value.id) === 340) {
                incomeFrequencyModeList.push({ label: 'Semi-Annual', id: 335 })
                incomeFrequencyModeList.push({ label: 'Quarterly', id: 336 })
                incomeFrequencyModeList.push({ label: 'Monthly', id: 337 })
            }
            formRef.$("income-frequency-mode").set("extra", {
                ...formRef.$("income-frequency-mode").extra,
                optionList: incomeFrequencyModeList || [],
            });
            Utils.updateBi(keys.PROPOSITION, field.value.id, props.data.package_id, formRef, props)

        }
    })


    formRef.$('auto-renewal-booster').observe({
        key: 'value',
        call: ({ field }) => {

            Utils.updateBi(keys.AUTO_RENEWAL_BOOSTER, field.value.id, props.data.package_id, formRef, props)

        }
    })
    formRef.$('accrual-period').observe({
        key: 'value',
        call: ({ field }) => {

            Utils.updateBi(keys.ACCUREAL_PERIOD, field.value.id, props.data.package_id, formRef, props)

        }
    })
    formRef.$('ROP').observe({
        key: 'value',
        call: ({ field }) => {

            Utils.updateBi(keys.ROP, field.value.id, props.data.package_id, formRef, props)

        }
    })
    // Addtional Rider

    formRef.$('ADB').observe({
        key: 'value',
        call: ({ field }) => {
            let adbValue = formRef.$('ADB-dropdown').value
            Utils.updateBi(keys.ADB_RIDER, adbValue, props.data.package_id, formRef, props)
        }
    })

    formRef.$('ATPDRider').observe({
        key: 'value',
        call: ({ field }) => {
            let atpdValue = formRef.$('ATPDRider-dropdown').value
            Utils.updateBi(keys.ATPD_RIDER, atpdValue, props.data.package_id, formRef, props)
        }
    })

    formRef.$('CriticalIllnessRider').observe({
        key: 'value',
        call: ({ field }) => {
            let criticalIllness = formRef.$('CriticalIllnessRider-dropdown').value
            Utils.updateBi(keys.Critical_ILLNESS_RIDER, criticalIllness, props.data.package_id, formRef, props)
        }
    })

    formRef.$('IncomeBenefitRider').observe({
        key: 'value',
        call: ({ field }) => {
            let incomeBuilder = formRef.$('IncomeBenefitRider-dropdown').value
            Utils.updateBi(keys.INCOME_BENEFIT_RIDER, incomeBuilder, props.data.package_id, formRef, props)
        }
    })

    formRef.$('PayorWaiverBenefitRider-dropdown').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.updateBi(keys.PWB_RIDER, field.value.id, props.data.package_id, formRef, props)
        }
    })

}

export default FormObserver
